var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { styled } from "../theme/ThemeHelpers";
import * as React from "react";
import * as _ from "lodash";
var AutoGridContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", ";\n    display: grid;\n    display: -ms-grid;\n    grid-template-columns: ", ";\n    -ms-grid-columns:", ";\n    grid-gap: ", "px;\n"], ["\n    width: ", ";\n    display: grid;\n    display: -ms-grid;\n    grid-template-columns: ", ";\n    -ms-grid-columns:", ";\n    grid-gap: ", "px;\n"])), function (p) { return p.fitted ? "fit-content" : "100%"; }, function (p) { return _.times(p.columns, function (i) { return "1fr "; }); }, function (p) { return _.times(p.columns, function (i) { return "1fr "; }); }, function (props) { return props.gap; });
var AutoGridChild = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    grid-row: ", ";\n    grid-column-start: ", ";\n    grid-column-end: ", ";\n    -ms-grid-row: ", ";\n    -ms-grid-column: ", ";\n    -ms-grid-column-span: ", ";\n"], ["\n    grid-row: ", ";\n    grid-column-start: ", ";\n    grid-column-end: ", ";\n    -ms-grid-row: ", ";\n    -ms-grid-column: ", ";\n    -ms-grid-column-span: ", ";\n"])), function (p) { return p.row; }, function (p) { return p.col; }, function (p) { return p.col + p.span; }, function (p) { return p.row; }, function (p) { return p.col; }, function (p) { return p.span; });
var AutoGrid = /** @class */ (function (_super) {
    __extends(AutoGrid, _super);
    function AutoGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoGrid.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var col = 1;
        var row = 1;
        return (React.createElement(AutoGridContainer, { columns: this.props.columns, gap: (_a = this.props.gap) !== null && _a !== void 0 ? _a : 0, fitted: (_b = this.props.fitted) !== null && _b !== void 0 ? _b : false }, React.Children.map(this.props.children, function (c, i) {
            var p = c.props;
            var curCol = col;
            var maxSpan = _this.props.columns - curCol + 1;
            var span = Math.min(p.hasOwnProperty("span") ? p.span : 1, maxSpan);
            col += span;
            var curRow = row;
            if (col > _this.props.columns) {
                col = 1;
                row++;
            }
            return (React.createElement(AutoGridChild, { col: curCol, span: span, row: curRow, key: i }, c));
        })));
    };
    return AutoGrid;
}(React.Component));
export default AutoGrid;
var AutoGridColumn = /** @class */ (function (_super) {
    __extends(AutoGridColumn, _super);
    function AutoGridColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoGridColumn.prototype.render = function () {
        return this.props.children;
    };
    return AutoGridColumn;
}(React.Component));
export { AutoGridColumn };
var templateObject_1, templateObject_2;
//# sourceMappingURL=AutoGrid.js.map